<template>
  <v-dialog v-model="dialog" scrollable width="800px">
    <v-card>
      <v-card color="#004884" flat dark>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline">
          {{cardTitle | translate}}
        </v-card-text>
      </v-card>
      <v-card-text>
        <v-layout row wrap justify-start>
          <v-flex>
            <v-card flat>
              <v-card-title>
                {{ $t(description, { countHits: countHits, estTime: estTime }) }}
              </v-card-title>
              <v-card-text>
                <v-text-field v-model="exportName" :label="$t(exportCaption)">
                </v-text-field>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="doExport" color="#004884" small dark outline class="radiusBtn text-none"> {{'BUTT_OK' | translate}}
        </v-btn>
        <v-btn @click="dialog=false" color="#004884" small dark outline class="radiusBtn text-none"> {{'BUTT_CANCEL' | translate}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'DialogDoExport',
    components: {},
    methods: {
      open: function (cardConfig) {
        if ((cardConfig != null) && (cardConfig)) {
          this.cardTitle = cardConfig.title;
          this.description = cardConfig.description;
          this.exportCaption = cardConfig.exportCaption;
          this.exportType = cardConfig.exportType;
          this.estTime = cardConfig.estTime;
          this.countHits = cardConfig.countHits;
          this.searchData = cardConfig.searchData;
        }
        this.dialog = true
      },
      doExport: function (event) {
        var url = Vue.prototype.storage.host() + '/apiDownloadCenter.php?create';
        $.ajax(url, {
          type: 'POST',
          data: JSON.stringify({exportName: this.exportName, exportType: this.exportType, searchData: this.searchData}),
          dataType: 'json',
          contentType : 'application/json',
          success: function (data, statusText, jqXHR) {
            this.dialog = false;
          }
        })
        .fail(function(xhr, status, error) {
          this.dialog = false;
          Vue.prototype.$api.onAjaxFailure(xhr, status, error);
        });
        this.dialog = false;
      }
    },
    data () {
      return {
        cardTitle: '',
        description: '',
        exportCaption: '',
        estTime: '',
        countHits: 0,
        exportName: '',
        exportType: '',
        dialog: false
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogDoExport.vue